import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { IItemSearch } from '../../../../models/IItemSearch';
import { SanitizeHtmlTextPipe } from '../../../../shared/pipes/sanitize-html-text.pipe';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBookmark as faBookmarkSolid, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { TimeLeftService } from '../../../../services/time-left.service';
import { AuthService, LOGIN_TYPE_TOPBAR } from '../../../../services/authentication/auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { FavoritesItemsService } from '../../../../services/favorites/favorites-items.service';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-item-vertical-template',
  imports: [SanitizeHtmlTextPipe,
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    ButtonModule
  ],
  templateUrl: './item-vertical-template.component.html',
  styleUrl: './item-vertical-template.component.scss'
})
export class ItemVerticalTemplateComponent implements OnInit {

  @Input() items: IItemSearch[] | null = null;
  @Output() favoriteStatus = new EventEmitter<{ isFavorite: boolean, itemId: number }>;

  faBookmarkSolid = faBookmarkSolid;
  faBookmarkRegular = faBookmarkRegular;
  faCreditCard = faCreditCard;

  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  protected readonly authService = inject(AuthService);
  protected readonly oidcSecurityService = inject(OidcSecurityService);
  protected readonly favoriteService = inject(FavoritesItemsService);
  timeLeftService = inject(TimeLeftService);

  isAuthenticated = this.oidcSecurityService.authenticated;

  ngOnInit(): void {

  }

  openLoginModal(fun?: () => void) {
    this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, fun ?? (() => { })
    );
  }


  toggleFavorite(itemId: number, isFavorite: boolean) {

    if (this.isAuthenticated().isAuthenticated) {
      this.changeFavoriteStatus(itemId, isFavorite);

    } else {
      this.openLoginModal(() => this.changeFavoriteStatus(itemId, isFavorite));
    }


  }

  changeFavoriteStatus(itemId: number, isFavorite: boolean) {

    if (isFavorite) {
      this.favoriteService.deleteFavorite(itemId).subscribe({
        next: () => {
          this.favoriteStatus.emit({ isFavorite, itemId });
        },
        error: (error) => {
          console.error('Favorite error:', error);
        }
      });

    } else {
      this.favoriteService.putFavorite(itemId).subscribe({
        next: () => {
          this.favoriteStatus.emit({ isFavorite, itemId });
        },
        error: (error) => {
          console.error('Favorite error:', error);
        }
      });
    }
  }

}
